import React, { ReactNode } from 'react';
import Icon from '../Icon';
import { CloseButton } from '../../DesignSystem/LiliCloseButton/CloseButton';

interface IProps {
    tooltipContainerClassName: string;
    tooltipContentClassName: string;
    exitIconClassName?: string;
    exitIcon?:boolean;
    exitIconSrc?: string;
    children: ReactNode;
    triangleClassName?: string;
    triangleClass?: string;
    showNewCloseIcon?: boolean;
    onCloseClick?: () => void;
}

const TooltipWithTriangle = ({
  tooltipContainerClassName, tooltipContentClassName, exitIcon, exitIconSrc, exitIconClassName, children, triangleClassName, triangleClass, showNewCloseIcon, onCloseClick,
}:IProps) => (
  <div id='TooltipWithTriangleContainer' className={tooltipContainerClassName}>
    {exitIcon && <Icon src={exitIconSrc || ''} className={`${exitIconClassName} relative`} /> }
    {showNewCloseIcon && <CloseButton onClick={onCloseClick || (() => {})} id='close-button' className='absolute top-3 right-3 cursor-pointer z-10 rounded-full fill-bw07 hover:bg-bw02' />}
    <div id='TooltipWithTriangleContent' className={tooltipContentClassName}>
      {children}
    </div>
    <div className={`${triangleClass ?? 'triangle-down'} ${triangleClassName}`} />
  </div>
);

export default TooltipWithTriangle;
